// 设置轻注册标记
$(function () {
    function setLightReg (){
        // 设置完善信息状态
        getUserInfoDef.then(function (opts, status) {
            if(!common.isLogin()){
                $('#assist-side-light-reg-btn').show();
                $('#assist-side-light-reg-completion-btn').hide();
            }else{
                $('#assist-side-light-reg-btn').hide();
            }


           /* // 只有1组2组才会有状态
            var userTeam = getUserInfo.getUserTeam();
            if(userTeam !== '1' && userTeam !== '2'){
                return;
            }*/
            // 登录状态下 没有姓名/邮箱/公司名称 会提示需要完善
            if((!opts.name || !opts.email || !opts.enterpriseName) && common.isLogin()){

                console.log('显示完善信息标识');

                window.cateData.needCompletionInfo = 1;

                // 导航添加完善信息
                $('.meCore-completion-tag').show();

                // 个人中心编辑按钮添加红点
                $('.m-info').addClass('m-info-completion-tag');
                $('.m-info').bind('click', function () {
                    gioTrackAction.gio_base('click_individualAddinfoCenter');
                });

                // 导航右上角个人位置 完善信息的点击事件
                $('.meCore-completion-tag').bind('click', function () {
                    gioTrackAction.gio_base('click_individualAddinfoTop');
                    window.location.href = solution_host + '/user/edit.html';
                });

                // 修改个人中心的修改信息为完善信息
                if(window.location.href.indexOf('dellemc-solution.com/user/') > -1 || window.location.href.indexOf('dellemc-solution.com/account/account') > -1){
                    $('#edit-user-info').text('完善信息');
                    $('#edit-user-info').addClass('user-tab-red-dot');
                    $('#edit-user-info').bind('click', function () {
                        gioTrackAction.gio_base('click_individualAddinfoCenter');
                    });
                }

                // 修改个人中心的个人信息编辑页面的 tab标题 和按钮文字
                if(window.location.href.indexOf('user/edit.html') > -1){
                    $('.act-changeinfo').text('完善信息');
                    $('.confirm_btn').text('确认完善信息');
                    $('.confirm-modify-info').text('确认完善信息'); //手机端
                    $('.act-changeinfo').bind('click', function () {
                        gioTrackAction.gio_base('click_individualAddinfoCenter');
                    });
                }

                // 手机端导航设置
                $('.nav-me').addClass('nav-red-dot');
                //手机端侧边按钮
                $('#assist-side-light-reg-completion-btn').show();

                // 显示补全信息弹窗
                if(common.getCookie('light_reg_need_completion') === '1'){
                    registEasyCompletionDialog.showDialog();
                    common.delCookie('light_reg_need_completion');
                }
            }
        })
    }
    setLightReg();
    window.setLightReg = setLightReg;

    // 滚动
    var $side = $('.assist-side-light-reg');
    $side.find('.right-fixed-bar-item').click(function () {
        if($side.hasClass('assist-side-light-reg-hide')){
            $side.removeClass('assist-side-light-reg-hide');
        }
    });

    /*$(document).scroll(function () {
        var windowH = window.innerHeight || document.documentElement.clientHeight;
        if($(window).scrollTop() > windowH){
            $side.addClass('assist-side-light-reg-hide');
        }else{
            $side.removeClass('assist-side-light-reg-hide');
        }
    });*/
});